import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl } from '../stores/APIEndpoints';
import { PDFDocument } from 'pdf-lib';
import { monthYearFromDate } from '../util/Util'; // Import inside store

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Payments. The Service is unavailable. Please try after sometime." };

export default class PaymentDetailsStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    payments = [];
    rowCount = 0;
    dailyInvoicesCount = 0;
    monthlyInvoicesCount = 0;
    totalIcPayable = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.referrerId = props.referrerId;
        this.collectionType = props.collectionType;

        makeObservable(this, {
            state: observable,
            message: observable,
            payments: observable,
            rowCount: observable,
            dailyInvoicesCount: observable,
            monthlyInvoicesCount: observable,
            totalIcPayable: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchPayments: action,
            // fetchPaymentsByCollection: action,
            generatePaymentData: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    fetchPayments = async () => {
        debugger;
        const paymentUrl = `${erpApiurl}api/carbon/GetInvioceSummary?ReferrerId=${this.referrerId}&collectionType=${this.collectionType}`

        let paymentData = await this.fetchByUrl(paymentUrl);

        this.generatePaymentData(paymentData);
    }

    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchByUrl = async (url) => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return [];
            }
            this.state = DONE;
            return data;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
        return [];
    }


    generatePaymentData = (paymentData) => {
        const data = [];

        for (let i = 0; i < paymentData.length; i++) {
            const item = paymentData[i];
            this.totalIcPayable = this.totalIcPayable + item.ICTotal;
            item["collectionType"] = this.collectionType;
            data.push(item);
        }

        if (this.collectionType == "daily") {
            this.dailyInvoicesCount = paymentData.length;
            this.monthlyInvoicesCount = 0;
        }
        else {
            this.dailyInvoicesCount = 0;
            this.monthlyInvoicesCount = paymentData.length;
        }

        this.payments = data;
        this.rowCount = data.length;
    }

    /**
     * 
     * @param {*} invoiceHeader 
     */
    showInvoice = async (invoiceHeader) => {

        const url = `${erpApiurl}api/carbon/GetIcInvoiceListByinvioce?invoiceno=${invoiceHeader.number}`;
        const data = await this.fetchByUrl(url);
        const summary = this.buildSummary(data);
        const payload = {
            header: invoiceHeader,
            items: data,
            summary: summary
        }

        const reportUrl = `https://numedlabs.com/mailer/mailer/settlements/reports/${invoiceHeader.number}`;
        const response = await this.apiProxy.asyncPost(reportUrl, payload);
        const reportId = await response.text();

        if (reportId === invoiceHeader.number) {
            return reportUrl;
        }

        console.log("Error in Creating Report");
        return "Error";
    }

    UpdateIcPrintStatus = async (number) => {

        const payload = {
            invoiceno: number,
        }

        const reportUrl = `${erpApiurl}api/Carbon/UpdateIcPrintStatus`;
        const response = await this.apiProxy.asyncPost(reportUrl, payload);
        const status = await response.json();

        console.log(status);
    }

    buildSummary = (data) => {
        const summary = {
            gross: 0,
            netDiscount: 0,
            net: 0
        };

        data.map((item) => {
            summary.gross = summary.gross + item.IC
        })
        summary.net = summary.gross - summary.netDiscount;
        return summary
    }

     /**
         * Merge multiple invoices into a single PDF
         * @param {*} selectedInvoices Array of invoice objects [{InvoiceNumber, InvoiceDate, Doctorname, collectionType}, ...]
         * @returns Blob of merged PDF
         */
        mergeInvoicesPdf = async (selectedInvoices, doctorName) => {
            if (!selectedInvoices.length) return null;
            const mergedPdf = await PDFDocument.create();
            const successfullyMerged = [];
            for (let invoice of selectedInvoices) {
                const invoiceHeader = {
                    name: doctorName,
                    number: invoice.InvoiceNumber,
                    period: invoice.collectionType === "daily" ? invoice.InvoiceDate.substr(0, 10) : monthYearFromDate(invoice.InvoiceDate)
                };
                try {
                    const url = await this.showInvoice(invoiceHeader);
                    if (!url) continue;
                    const pdfBytes = await fetch(url).then(res => res.arrayBuffer());
                    const pdf = await PDFDocument.load(pdfBytes);
                    const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
                    copiedPages.forEach(page => mergedPdf.addPage(page));
                    if (url) {
                        successfullyMerged.push(invoiceHeader);
                    }
                } catch (e) {
                    console.error(`Failed to merge invoice ${invoice.InvoiceNumber}:`, e);
                }
            }
            const mergedPdfBytes = await mergedPdf.save();
            return { blob: new Blob([mergedPdfBytes], { type: 'application/pdf' }), mergedInvoices: successfullyMerged };
        }
    
        UpdateMultipleIcPrintStatus = async (selectedInvoices) => {
            if (!selectedInvoices.length) return null;
            console.log("Updating multiple invoice statuses:", selectedInvoices);
            const updatePromises = selectedInvoices.map(invoice => {
                const payload = { invoiceno: invoice.number };
                const url = `${erpApiurl}api/Carbon/UpdateIcPrintStatus`;
                return this.apiProxy.asyncPost(url, payload)
                    .then(response => response.json())
                    .catch(e => {
                        console.error(`Failed to update status for ${invoice.number}`, e);
                        return null;
                    });
            });
    
            const results = await Promise.all(updatePromises);
            return results;
        };
}
